module.exports = __webpack_public_path__ + "img/s6img1_big.9b8a347.3d6682a7.png";